import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useMember } from '~/components/Member/Member.hooks';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export type VaultStatus = {
  registered: boolean;
  sellerInfoUrl?: string;
};

export const vaultStatusUrl = '/api/citizen/v1/ncw/registered';

export const getVaultStatus = async () => {
  const { data } = await axios.get<VaultStatus>(vaultStatusUrl);
  return data;
};

/**
 * @deprecated use useWalletStatus
 */
export const useVaultStatus = (options?: UseDosiminQueryOptions<VaultStatus>) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  return useQuery<VaultStatus>({
    queryKey: ['wallet', 'vault', 'status'],
    queryFn: getVaultStatus,
    initialData: { registered: false, sellerInfoUrl: '' },
    enabled: isLoggedIn,
    ...options,
  });
};
